import {useStaticQuery, graphql} from 'gatsby';
export const useFooterData = () => {
	const {sanityFooter, sanitySiteGlobal} = useStaticQuery(
		graphql`
			query FooterQuery {
				sanityFooter {
					general: _rawFooterGeneral(resolveReferences: {maxDepth: 3})
					simple: _rawFooterSimple(resolveReferences: {maxDepth: 3})
					landingPage: _rawFooterLandingPage(
						resolveReferences: {maxDepth: 3}
					)
					subscribePrompt
					menuSections: _rawMenuSections(
						resolveReferences: {maxDepth: 8}
					)
					mobileMenu: _rawMobileMenu(resolveReferences: {maxDepth: 8})
				}
				sanitySiteGlobal {
					content {
						social {
							instagram
							pinterest
						}
					}
				}
			}
		`,
	);

	return {footer: sanityFooter, social: sanitySiteGlobal.content.social};
};
